import { Step } from 'react-joyride';

export const sellerNotificationsSteps: Step[] = [
  {
    target: 'body',
    content: 'Track buyer interest and activity on your property listings.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="notifications-header"]',
    content: 'See your unread count and quickly mark all notifications as read.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="notification-card"]',
    content: 'Each notification shows which buyer viewed or made an offer on your property, with their contact details.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="property-context"]',
    content: 'Property information is included so you know exactly which listing attracted interest.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="add-to-list"]',
    content: 'Add interested buyers to your custom lists for future marketing and follow-ups.',
    disableBeacon: true,
  },
];
